// extracted by mini-css-extract-plugin
export default {"hasFiltersDot":"knowleageBaseFilters_hasFiltersDot__driKA"};